@if (socialMediaLinksWithIcon) {
    <nav
        class="social-media-links"
        [attr.aria-labelledby]="title ? labelId : null"
        [attr.aria-label]="title ? null : 'Social media'">
        @if (title) {
            <span
                [id]="labelId"
                data-cy="text"
                class="sir-text-style-paragraph-m-bold">
                {{ title }}
            </span>
        }
        <ul class="links">
            @for (item of socialMediaLinksWithIcon; track item.link) {
                <li>
                    <a [siriusLink]="item.link">
                        <sirius-icon
                            data-cy="icon"
                            [name]="item.icon"
                            aria-hidden="true"></sirius-icon>
                    </a>
                </li>
            }
        </ul>
    </nav>
}
